"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardsRoot = exports.RootAccountData = void 0;
const common_1 = require("@everlend/common");
const rewardProgram_1 = require("../rewardProgram");
class RootAccountData extends common_1.Borsh.Data {
}
exports.RootAccountData = RootAccountData;
_a = RootAccountData;
RootAccountData.SCHEMA = _a.struct([
    ['accountType', 'u8'],
    ['authority', 'publicKey'],
]);
class RewardsRoot extends common_1.Account {
    constructor(publicKey, info) {
        super(publicKey, info);
        if (!this.assertOwner(rewardProgram_1.RewardProgram.PUBKEY)) {
            throw common_1.Errors.ERROR_INVALID_OWNER();
        }
        this.data = RootAccountData.deserialize(this.info.data);
    }
}
exports.RewardsRoot = RewardsRoot;
//# sourceMappingURL=rewardsRoot.js.map